import {
  FETCH_USER_ACTIVITY_REQUEST,
  FETCH_USER_ACTIVITY_SUCCESS,
  FETCH_USER_ACTIVITY_FAILURE,
  CLEAR_USER_ACTIVITY,
} from './userActivityLogTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const userActivityLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_ACTIVITY_REQUEST:
      return { loading: true, data: null, error: null };
    case FETCH_USER_ACTIVITY_SUCCESS:
      return { loading: false, data: action.payload, error: null };
    case FETCH_USER_ACTIVITY_FAILURE:
      return { loading: false, data: null, error: action.payload };
    case CLEAR_USER_ACTIVITY:
      return initialState;
    default:
      return state;
  }
};

export default userActivityLogReducer;
